import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CreateChannelScenarioModal } from './CreateChannelScenarioModal';

export function ChannelScenarios() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [scenarios, setScenarios] = useState([]);

  useEffect(() => {
    const storedScenarios = JSON.parse(localStorage.getItem('channelScenarios') || '[]');
    // Sort by most recent first
    setScenarios(storedScenarios.sort((a, b) => b.id - a.id));
  }, []);

  const handleDeleteScenario = (id, e) => {
    e.preventDefault(); // Prevent navigation
    const updatedScenarios = scenarios.filter(scenario => scenario.id !== id);
    localStorage.setItem('channelScenarios', JSON.stringify(updatedScenarios));
    setScenarios(updatedScenarios);
  };

  return (
    <main className="main-content">
      <h1 className="page-title">Channel Selection and Optimization</h1>

      <div className="optimizer-content">
        <button 
          className="create-scenario-button"
          onClick={() => setShowCreateModal(true)}
        >
          Create New Scenario
        </button>

        <div className="scenarios-section">
          <h2 className="section-title">Recent Scenarios</h2>
          
          {scenarios.length === 0 ? (
            <div className="no-scenarios">
              No scenarios created yet. Click "Create New Scenario" to get started.
            </div>
          ) : (
            scenarios.map(scenario => (
              <Link 
                to={`/channels/select/${scenario.id}`} 
                key={scenario.id}
                className="scenario-card"
              >
                <div className="scenario-content">
                  <div className="scenario-name">{scenario.name}</div>
                  <div className="scenario-details">
                    <span className="detail-item">
                      <span className="detail-label">Date Range:</span> {scenario.dateRange}
                    </span>
                    <span className="detail-item">
                      <span className="detail-label">Budget:</span> {scenario.budget}
                    </span>
                    <span className="detail-item">
                      <span className="detail-label">Channels Selected:</span> {scenario.channelsSelected}
                    </span>
                  </div>
                </div>
                <button
                  className="delete-scenario-button"
                  onClick={(e) => handleDeleteScenario(scenario.id, e)}
                >
                  Remove
                </button>
              </Link>
            ))
          )}
        </div>
      </div>

      {showCreateModal && (
        <CreateChannelScenarioModal onClose={() => setShowCreateModal(false)} />
      )}
    </main>
  );
} 